import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.element.querySelectorAll('.collapse').forEach(collapse => {
      collapse.addEventListener('show.bs.collapse', (event) => {
        event.target.previousElementSibling.classList.add('d-none')
      })

      collapse.addEventListener('hide.bs.collapse', (event) => {
        event.target.previousElementSibling.classList.remove('d-none')
      })
    })
  }
}
